<template>
	<div>
		<nav class="navbar navbar-expand-md fixed-top app-shadow app-top-nav">
			<a class="navbar-brand d-none d-xl-block pl-3" href="#/" v-if="location.logo">
				<img :src="`${location.logo}`" style="max-height: 40px;">
			</a>
			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
					aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse app-nav" id="navbarCollapse">
				<ul class="navbar-nav text-uppercase flex-grow-1 main-menu align-items-center">

					<li class="nav-item font-lg">
						<router-link to="/" class="nav-link border-left border-right px-4" exact>Location</router-link>
						<small class="item-label">
							<span class="fas fa-flag text-danger" v-if="Object.keys(alert).length > 0"></span>
							<span class="text-muted">{{ Object.keys(alert).length }}</span>
						</small>

					</li>
					<li class="nav-item font-lg" v-if="$auth.hasAccess('project')">
						<router-link to="/project" class="nav-link border-right px-4">Project</router-link>
					</li>
					<li class="nav-item font-lg" v-if="$auth.hasAccess('assets')">
						<router-link to="/location/assets" class="nav-link px-4 border-right">Assets</router-link>
						<span class="item-label text-muted">{{ assets_count }}</span>
					</li>
					<li class="nav-item px-4">
						<small style="text-transform: none">Day {{ day }} : {{clock}}</small>
					</li>
				</ul>

				<img v-if="location.logo_secondary" :src="`${location.logo_secondary}`" style="max-height: 40px; max-width: 120px">

				<ul class="navbar-nav ml-auto pr-3 align-items-center">
					<li class="nav-item mr-2">
						<a class="nav-link text-muted"><span style="text-transform: none">Welcome, {{user.first_name}} {{user.last_name}}</span></a>
					</li>
					<li class="nav-item">
						<a class="nav-link text-muted rounded-circle hover-link" href="#" @click.prevent="show_help=true"><i class="far fa-question-circle"></i></a>
					</li>
					<li class="nav-item">
						<a href="#" class="nav-link rounded-circle hover-link text-muted" @click.prevent="$auth.logout()"><i class="fas fa-sign-out-alt"></i></a>
					</li>

				</ul>
			</div>
		</nav>

		<b-modal ref="help-modal" title="Help" v-model="show_help" :modal-class="'app-modal'" centered size="lg">

			<div v-if="$route.name == 'project'">
				<h5>Project Tab</h5>
				<p>
					Welcome to Supervisor, the SmartConnect solution simulator. Through real time
					scenario demonstration, you can explore all of the capabilities of the SmartConnect hardware and software.
				</p>

			</div>

			<div v-else>
				<h5>Quick Start Guide</h5>
				<p>
					Welcome to Supervisor, the SmartConnect solution simulator. Through real time
					scenario demonstration, you can explore all of the capabilities of the SmartConnect hardware and software.
				</p>

				<div class="row mb-3 mt-4">
					<div class="col-sm-2">
						<img class="img-fluid" src="~assets/img/footer/play.png" alt="Play Button" style="width: 45px" />
					</div>
					<div class="col-sm-10">
						<h6 class="text-uppercase mb-0">STARTING A SCENARIO</h6>
						<p>Use the Play button in the bottom black bar to start or pause movement within the game.</p>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-2">
						<img class="img-fluid" src="~assets/icons/fast-forward.png" alt="Fast forward" style="width: 45px"  />
					</div>
					<div class="col-sm-10">
						<p>To speed the game up to as much as 20X real time, click the fast forward button in the Time Warp control. Continually clicking will cycle through the game speeds.</p>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-2">
						<img class="img-fluid" src="~assets/icons/skip-forward.png" alt="Skip forward" style="width: 45px"  />
					</div>
					<div class="col-sm-10">
						<p>To simulate as much as 10 days of event scenarios, including asset movement and all recorded events, click the <i class="app-icon skip-forward"></i> button in the bottom black bar.</p>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-2">
						<img class="img-fluid" src="~assets/img/footer/havoc.png" alt="Play Button" style="width: 75px" />
					</div>
					<div class="col-sm-10">
						<h6 class="text-uppercase mb-0">HAVOC</h6>
						<p>Activating the Havoc mode will force safety events such as Man Down and Restricted Area Entry to happen at a significantly higher rate than normal mode.
						</p>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-2 text-danger">
						<big>1 Alert</big>
					</div>
					<div class="col-sm-10">
						<h6 class="text-uppercase mb-0">RESPONDING TO EVENTS</h6>
						<p>When a simulatred safety event is recorded, a red flag will show in the top of the view screen window and a new event will show in the right Location sidebar. Click on the red line item and select th listed event to choose how you want to respond.</p>
					</div>
				</div>
			</div>

			<div slot="modal-footer">
				<button type="button" class="btn btn-dark pl-4 pr-4" @click="show_help=false">Ok</button>
			</div>



		</b-modal>
	</div>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Header',
		data() {
			return {
				short_clock: '',
				show_help: false
			}
		},
		mounted() {
			this.setClock();

			if (!localStorage.getItem('touch')) {
				this.show_help = true;
				localStorage.setItem('touch', true);
			}
		},
		methods: {
			setClock() {
				let moment_time = moment().add(this.day - 1, 'days').hour(this.start_time.hour).minute(this.start_time.minute).second(this.time);
				this.short_clock = moment_time.format("h:mm a");
				this.clock = moment_time.format("M/D/YY h:mm:ssa")
			}
		},
		watch: {
			time() {
				this.setClock()
			},
			day() {
				this.setClock();
			},
			show_help() {

			}
		},
		computed: {
			location() {
				return this.$store.state.location
			},
			user() {
				return this.$store.state.user
			},
			time() {
				return this.$store.state.time
			},
			assets_count() {
				return Object.keys(this.$store.state.workers).length
			},
			day() {
				return this.$store.state.day
			},
			start_date() {
				return this.$store.state.start_date
			},
			start_time() {
				return this.$config.start_time
			},
			end_time() {
				return this.$config.end_time
			},
			clock: {
				get() {
					return this.$store.state.clock
				},
				set(value) {
					this.$store.commit('setState', ['clock', value])
				}
			},
			speed: {
				get() {
					return this.$store.state.speed
				},
				set(value) {
					this.$store.commit('set_speed', value)
				}
			},
			alert() {
				return this.$finder.all({'status': 'pending'}, this.$store.state.alert)
			},
			extended: {
				get(){
					return this.$store.state.bottom_menu_collapsed
				}
			},
			view() { return this.$store.state.view },
		}
	}
</script>
